// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"InputArea_inputArea__LOTV2","clearBtn":"InputArea_clearBtn__hwIfN","inputAreaWithoutSuggest":"InputArea_inputAreaWithoutSuggest__hI0dv"};